import React from 'react'

const NADLLandingPage = () =>
  <div className='admin-gear-landing-page'>
    <h3>Welcome to Native American Direct Loans Data Consolidation.</h3>

    <p>This is a modernization of the former NADL app that was hosted in Cleveland.
      You can view, edit, or add new records in <b>Record Maintenance</b> and view reports in <b>Run Reports</b>.</p >
  </div>

export default NADLLandingPage